import api from "../../BrandOnBoarding/api";

export async function fetchCategoryMonitoringOptions(customerId) {
  const response = await api.get(`/category-monitoring/options?customer_id=${customerId}`);
  return response.data?.data ?? [];
}

export async function fetchCategoryMonitoringDetail({ customerId, category, llmId, marketId }) {
  const response = await api.get("/category-monitoring/detail", {
    params: {
      customer_id: customerId,
      category,
      llm_id: llmId,
      market_id: marketId,
    },
  });
  return response.data?.data ?? null;
}

export async function fetchCategoryMonitoringConsensus({ customerId, category, marketId }) {
  const response = await api.get("/category-monitoring/consensus", {
    params: {
      customer_id: customerId,
      category,
      market_id: marketId,
    },
  });
  return response.data?.data ?? null;
}
